import React, { useState } from 'react';
import { TextInput } from '@workday/canvas-kit-react/text-input';
import { autoId } from '@workday/upc-common';
import { TertiaryButton } from '@workday/canvas-kit-react/button';
import { invisibleIcon, visibleIcon } from '@workday/canvas-system-icons-web';
import styles from './password-input.module.scss';
import classNames from 'classnames';
import { ID_SHOW_PASSWORD_ICON } from '../../autoIds';
import { useTranslation } from 'react-i18next';
import { DefaultTFuncReturn } from 'i18next';

export interface PasswordTextInputProps {
    id?: string | undefined;
    testId: string;
    inputRef?: any;
    inputProps?: any; // React.ReactNode?
    placeholder?: DefaultTFuncReturn;
    disabled?: boolean;
    autoFocus?: boolean;
    autoComplete?: string;
    className?: string;
}

export const OldPasswordInput = ({
    id,
    testId,
    inputRef,
    inputProps,
    placeholder,
    disabled,
    autoFocus,
    autoComplete,
    className,
    ...rest
}: PasswordTextInputProps) => {
    const [showPassword, setShowPassword] = useState(false);
    const { t } = useTranslation('auth');

    return (
        <div className={classNames(styles.container, className)}>
            <TextInput
                id={id}
                {...autoId(testId)}
                {...inputProps}
                ref={inputRef}
                disabled={disabled}
                placeholder={placeholder}
                type={showPassword ? 'text' : 'password'}
                grow={true}
                autoFocus={autoFocus}
                autoComplete={autoComplete}
                {...rest}
            />
            <TertiaryButton
                aria-label={t('PasswordInput.showPassword')}
                icon={showPassword ? invisibleIcon : visibleIcon}
                size='small'
                className={styles.iconButton}
                data-testid={ID_SHOW_PASSWORD_ICON}
                role='switch'
                type='button'
                disabled={disabled}
                aria-checked={showPassword}
                onClick={() => setShowPassword(!showPassword)}
            />
        </div>
    );
};
